module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10014.38e55f9c.jpg";